<script>
    export let name = ''
    $: icon = require(`/../resources/shapes/SVG/${name}.svg`)
</script>

{#if icon}
    {@html icon}
{/if}
